export const rentalPlanRule = (value, setData, itemList, formType) => {
  const numberOfPaymentsItem = itemList.findIndex(
    (f) =>
      f.field.id === 'number_of_payments' || f.field.id === 'number_of-payments'
  );
  if (numberOfPaymentsItem === -1) return;

  if (formType === 1 && (value === 'Monthly' || !value)) {
    setData('number_of_payments', {});
    setData('number_of-payments', null);
  } else if (formType === 2 && (value === 'Monthly' || !value))
    setData(null, 0, 'number_of_payments');
};
